const MinhasCompras = () => import('@/views/MinhasCompras.vue');
const NaoEncontrei = () => import('@/views/NaoEncontrei.vue');
const Motivos = () => import('@/views/Motivos.vue');
const MotivosDiscordar = () => import('@/views/MotivosDiscordar.vue');
const ObservacoesDiscordar = () => import('@/views/ObservacoesDiscordar.vue');
const SolicitacaoReembolso = () => import('@/views/SolicitacaoReembolso.vue');
const OutrosMotivosReembolso = () => import('@/views/OutrosMotivosReembolso.vue');
const AcompanharReembolso = () => import('@/views/AcompanharReembolso.vue');
const DevolucaoProduto = () => import('@/views/DevolucaoProduto.vue');

const routes = [
  {
    path: '/nao-encontrei-o-que-preciso',
    name: 'nao-encontrei-o-que-preciso',
    component: NaoEncontrei,
    meta: {
      title: 'Ainda preciso de ajuda',
    },
  },
  {
    path: '/nao-encontrei-o-que-preciso/modal',
    name: 'nao-encontrei-o-que-preciso-modal',
    component: MinhasCompras,
    meta: {
      title: 'Ainda preciso de ajuda',
    },
  },
  {
    path: '/nao-encontrei-o-que-preciso/motivo',
    name: 'nao-encontrei-o-que-preciso/motivo',
    component: Motivos,
    meta: {
      title: 'Preciso de ajuda com a minha compra',
    },
  },
  {
    path: '/nao-encontrei-o-que-preciso/motivo/outros',
    name: 'nao-encontrei-o-que-preciso/motivo/outros',
    component: OutrosMotivosReembolso,
    meta: {
      title: 'Preciso de ajuda com a minha compra',
    },
  },
  {
    path: '/solicitacao-de-reembolso',
    name: 'solicitacao-de-reembolso',
    component: SolicitacaoReembolso,
    meta: {
      title: 'Solicitação de reembolso',
    },
  },
  {
    path: '/solicitacao-de-reembolso/corrigir-dados-bancarios',
    name: 'corrigir-dados-bancarios',
    component: SolicitacaoReembolso,
    meta: {
      title: 'Corrigir dados bancários',
    },
  },
  {
    path: '/acompanhar-solicitacao-reembolso/:codigo_venda/:codigo_reembolso',
    name: 'acompanhar-solicitacao-reembolso',
    component: AcompanharReembolso,
    meta: {
      title: 'Acompanhar reembolso',
    },
  },
  {
    path: '/acompanhar-solicitacao-reembolso/motivos-discordar',
    name: 'acompanhar-solicitacao-reembolso-motivos-discordar',
    component: MotivosDiscordar,
    meta: {
      title: 'Discordo do vendedor',
    },
  },
  {
    path: '/acompanhar-solicitacao-reembolso/discordar',
    name: 'acompanhar-solicitacao-reembolso-discordar',
    component: ObservacoesDiscordar,
    meta: {
      title: 'Discordo do vendedor - Observações',
    },
  },
  {
    path: '/devolucao-produto',
    name: 'devolucao-produto',
    component: DevolucaoProduto,
    meta: {
      title: 'Devolução do produto',
    },
  },
];

export default routes;
